import axios from 'axios';

export const setUserIpAddress = () => {
    axios.get("https://api.ipify.org/?format=json").then(response => {
        sessionStorage.setItem('user-ip', response.data.ip);
    })
}


// WEBPACK FOOTER //
// ./src/helpers/utility.helper.js